import request from '../services/request';

export const get = ({ taxonTypes }) => request.get('/contacts/csv', { params: { taxonTypes: JSON.stringify(taxonTypes) } });

export const sendMessages = params => request.post('/contacts/send-messages', params);
